import React, { useCallback, useState } from "react";

import NoticesTable from "../Notice/NoticesTable";
import { prepareParams } from "../Notice/utils";
import { getNotices } from "../../store/api/notices";

const LatestNotices = () => {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [notices, setNotices] = useState([]);

  const fetchData = useCallback((params) => {
    setLoading(true);
    getNotices({ ...prepareParams(params), showOnPopup: true })
      .then(({ data }) => {
        setNotices(data.notices);
        setTotal(data.totalCount);
      })
      .catch(() => {
        //
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <section className="home-notices-popup">
      <h3 style={{ fontWeight: "bold" }}>Popup notices</h3>
      <p style={{ color: "#777777" }}>
        List of notices to show on the popup in the home page.
      </p>
      <div style={{ marginTop: "-2rem", width: "100%" }}>
        <NoticesTable
          notices={notices}
          handleFetch={fetchData}
          loading={loading}
          total={total}
          showFilters={false}
          visibleColumns={[
            "noticeDate",
            "title",
            "category",
            "filePath",
            "isPublished",
            "showOnPopup",
            "showOnPopupUntil",
            "actions",
          ]}
          showDeleteAction={false}
          showArchiveAction={false}
          allowPublish={false}
        />
      </div>
    </section>
  );
};

export default LatestNotices;
